<template>
  <div id="test">
    <el-card>
      value: {{ test }}
    </el-card>
  </div>
</template>

<script>
export default {
  computed: {
    test() {
      console.log(process.env);
      return process.env.VUE_APP_TEST;
    },
  },
};
</script>

<style lang="scss" scoped>
#test {
  height: 100%;
  padding: 150px 300px;

  // @media (prefers-color-scheme: dark) {
  //   // DARK MODE
  //   background-image: radial-gradient(circle at bottom left, #383838, black);
  // }
}
</style>
